module.exports = __webpack_public_path__ + "img/Ecuador.fc55aef1.svg";